import React from 'react'

const UpdatePod = () => {
  return (
    <div>UpdatePod</div>
  )
}

export default UpdatePod